module.exports = require('./dist/bundle.js');




//////////////////
// WEBPACK FOOTER
// ./~/re-base/index.js
// module id = 81
// module chunks = 0